// extracted by mini-css-extract-plugin
export default {"text":"ProblemTestcaseModal_text__7iPqG","textLight":"ProblemTestcaseModal_textLight__Vytev","textDark":"ProblemTestcaseModal_textDark__3zGSX"};